// extracted by mini-css-extract-plugin
export default {"button":"GreenButton_button__B+004"};